import { TaskOverrideMapping } from '../../interfaces/execute-flow/task-override-mapping';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { TaskMapping } from '../flow-config/task-mapping';
import { MicroTaskConfig } from '../micro-task/micro-task-config';
import { FlowEnding } from './flow-ending';

/**
 * Configuration for an ExecuteFlow task — embeds another iHub flow as a sub-flow
 * inline within the parent flow. The parent flow engine expands this task directly;
 * the task service throws if invoked directly. Exit routing is defined by flowEndings.
 */
export class ExecuteFlowConfig extends DestinationTaskConfigBase {
	/**
	 * Reference ID of the iHub flow to embed as a sub-flow.
	 * @default ''
	 */
	flowReferenceId = '';

	/**
	 * Specific version ID of the sub-flow to use. Leave blank to use the latest
	 * published version.
	 * @default ''
	 */
	flowVersionID = '';

	/**
	 * Maps parent-flow task reference IDs to the actual task IDs instantiated within
	 * the sub-flow. Populated and managed by the flow builder.
	 * @default []
	 */
	taskMappings: TaskMapping[] = [];

	/**
	 * Embedded task configurations for each task inside the sub-flow.
	 * Populated by the flow builder when the sub-flow is loaded.
	 * @default []
	 */
	subTaskConfigs: MicroTaskConfig[] = [];

	/**
	 * Named exit points from the sub-flow. Each entry maps a sub-flow termination
	 * point (label + taskName) back to a parent flow task via successMappingID.
	 * @default []
	 */
	flowEndings: FlowEnding[] = [];

	/**
	 * Allows specific sub-flow tasks to be replaced with alternative tasks at runtime.
	 * Each entry specifies taskReferenceId, originalTaskID, and overrideTaskID.
	 * Managed by the flow builder.
	 * @default []
	 */
	taskOverrideMapping: TaskOverrideMapping[] = [];

	constructor(init?: Partial<ExecuteFlowConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}

	override GetDestinationTasks(): string[] {
		const taskDestinations: string[] = [];
		for (const flowEnding of this.flowEndings) {
			taskDestinations.push(flowEnding.successMappingID);
		}
		return taskDestinations;
	}
}
